import { render, staticRenderFns } from "./ProductShareButtons.vue?vue&type=template&id=2e60706a"
import script from "./ProductShareButtons.vue?vue&type=script&lang=js"
export * from "./ProductShareButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports